import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useLazyGetAuctionSmsCountersQuery } from '../../../../services/api/auctions-list';
import styled from 'styled-components';
import { NotificationBell } from '../../../../components/Icons/NotificationBell';
import { Popover } from '@material-ui/core';

const NotificationIconWrapper = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eeeeee;
  border-radius: 100%;
  cursor: pointer;
  margin-left: 12px;
`;

const CounterWrapper = styled.div`
  display: flex;
  padding: 8px;
  flex-direction: column;
  gap: 4px;

  & > span {
    font-size: 14px;
  }
`;

export const SmsCounters = () => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleBellIconClick = e => {
    setAnchorEl(e.currentTarget);
  };

  const closePopover = () => setAnchorEl(null);

  const { id: auctionId } = useParams();

  const [fetchSmsCounters, { data }] = useLazyGetAuctionSmsCountersQuery();

  useEffect(() => {
    if (anchorEl) {
      fetchSmsCounters(auctionId);
    }
  }, [anchorEl]);

  return (
    <>
      <NotificationIconWrapper onClick={handleBellIconClick}>
        <NotificationBell />
      </NotificationIconWrapper>
      <Popover
        onClose={closePopover}
        open={!!anchorEl}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        <TooltipCounters counters={data} />
      </Popover>
    </>
  );
};

const TooltipCounters = ({ counters }) => {
  return (
    <CounterWrapper>
      <span>{`Admin (${counters?.admin || 0})`}</span>
      <span>{`Seller (${counters?.seller || 0})`}</span>
      <span>{`Buyer (${counters?.buyer || 0})`}</span>
    </CounterWrapper>
  );
};
